import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FireExtinguisherIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fire_extinguisher"}/>
}
